export const CommonButtonTypes = {
    MODIFY_LEASE: 'MODIFY',
    TERMINATE_LEASE: 'TERMINATE',
    EXPORT_ALL_LEASE: 'EXPORT ALL',
    EXPORT_LEASE: 'EXPORT VIEW',
    EXPORT: 'EXPORTS',
    EDIT: 'EDIT',
};

export const flow ={
    EDIT: 'EDIT',
    VIEW: 'VIEW',
}

